<template>
    <MainPage :pageTitle="lbl.privilege.topbar_title" bgClass="bg-a-gray-efefef" menuBar>
        <div class="pt-3 pb-5">
            <CategoryList class="mb-5 px-6"
                :categoryConfig="categoryConfig"
                @onSelectCat="onSelectCat($event)">
            </CategoryList>
            <DashboardSlider
                class="pl-6 px-26"
                :apiConfig="dashboardConfig"
                @onLoaded="onLoadSuccess('dashboard')">
            </DashboardSlider>
            <CampaignList
                ref="campaign-list"
                class="px-26"
                :linkCategory="true"
                :initListConfig="listConfig"
                :initFilterConfig="filterConfig"
                @onLoaded="onLoadSuccess('campaign')"
            ></CampaignList>
        </div>
    </MainPage>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import CategoryList from '../component/CategoryList/CategoryList.vue'
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
import CampaignList from "../component/CampaignList/CampaignList.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "Privilege",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        MainPage,
        CategoryList,
        DashboardSlider,
        CampaignList,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            dashboardConfig: "tbank_privilege_dashboard",
            categoryConfig: null,
            listConfig: null,
            filterConfig: null,

            loadingStatus: {
                dashboard: false,
                campaign: false,
            },
        };
    },
    created: function() {
        this.tracking.screenName('privilege_page_list')
        this.tracking.event("privilege_page_list", "click_privilege_menu", "", "");

        this.setScrollLoadMore();
        this.initialCategoryConfig();
        this.initialCampaignConfig();
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        initialCategoryConfig: function(){
            let configStr = ConfigManager.getCategoryConfig();

            let categoryMenuConfig = new CategoryConfigBuilder()
                .setConfig(configStr.menuPrivilege)
            this.categoryConfig = categoryMenuConfig.create();
        },
        initialCampaignConfig: function(category) {
            let configStr = ConfigManager.getCampaignConfig();
            let listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr.campaignPrivilege)
                .setTop(25)

            if (category) {
                listConfig.setCatId(category.cat.id);
            }

            this.listConfig = listConfig.create();

            let filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },

        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },

        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },

        onSelectCat: function(category){
            this.tracking.event("privilege_page_list", "click_category", category.cat.id + '|' + category.cat.name , "");
            this.initialCampaignConfig(category);
            this.$refs['campaign-list'].reinitList(this.listConfig, this.filterConfig);
        },

        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.modal.loadingModal.hide();
                }
            }
        },
    },
}
</script>

